import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from "../classNames.js";
export const Field = ({ children, className, hasAddons, isGrouped, ...props }) => {
    const _class = classNames("field", hasAddons
        ? hasAddons === true
            ? "has-addons"
            : `has-addons-${hasAddons}`
        : undefined, isGrouped !== undefined ? "is-grouped" : undefined, typeof isGrouped === "string" ? `is-grouped-${isGrouped}` : undefined, className);
    return (_jsx("div", { className: _class, ...props, children: children }));
};
export const FieldHorizontal = ({ children, label, className, ...props }) => {
    const _class = classNames("field", "is-horizontal", className);
    return (_jsxs("div", { className: _class, ...props, children: [_jsx("div", { className: "field-label", children: label }), _jsx("div", { className: "field-body", children: children })] }));
};
